export default {"src":"/_next/static/image/src/images/SocialMediaIcons/facebook.5fc6b325e9ab2e4c32ec522e9b0a3d6b.svg","height":24,"width":25};